import { getWebPushPublicKey } from "../config/env";
import { addWebPushSubscription } from "../services/notifications";

export async function subscribeToWebPush(): Promise<void> {
  const publicKey = getWebPushPublicKey();
  if (!publicKey) {
    throw new Error("WEB_PUSH_PUBLIC_KEY_MISSING");
  }
  if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("WEB_PUSH_UNSUPPORTED");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("WEB_PUSH_PERMISSION_DENIED");
  }
  const registration = await navigator.serviceWorker.register("/sw.js");
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToArrayBuffer(publicKey)
  });
  const json = subscription.toJSON();
  await addWebPushSubscription({
    endpoint: json.endpoint ?? subscription.endpoint,
    p256dh: json.keys?.p256dh ?? "",
    auth: json.keys?.auth ?? ""
  });
}

function urlBase64ToArrayBuffer(base64String: string): ArrayBuffer {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`.replaceAll("-", "+").replaceAll("_", "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray.buffer.slice(0);
}
